import { FC } from "react";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetAggregationsByIdSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetAggregationsByIdSelector";
import { normalizedCostWidgetByWidgetIdDataSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetByWidgetIdDataSelector";
import { NormalizedCostWidgetAggregations } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/NormalizedCostWidgetAggregations";
import { normalizedCostWidgetForecastOptionByIdSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetForecastOptionByIdSelector";

interface NormalizedCostWidgetContentAggregationsProps {
  widgetId: string;
}

export const NormalizedCostWidgetContentAggregations: FC<
  NormalizedCostWidgetContentAggregationsProps
> = ({ widgetId }) => {
  const aggregation = useAppSelector((state) =>
    normalizedCostWidgetAggregationsByIdSelector(state, widgetId),
  );
  const widgetData = useAppSelector((state) =>
    normalizedCostWidgetByWidgetIdDataSelector(state, widgetId),
  );
  const forecastOption = useAppSelector((state) =>
    normalizedCostWidgetForecastOptionByIdSelector(state, widgetId),
  );

  return (
    <NormalizedCostWidgetAggregations
      totalCost={widgetData?.total_cost}
      totalCostTrend={widgetData?.trend}
      aggregations={aggregation ?? {}}
      forecastOption={forecastOption ?? "month"}
      forecastedCosts={widgetData?.forecasted_costs}
      averageNormalizedMonthlyCost={widgetData?.average_normalized_monthly_cost}
    />
  );
};
